import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  namespaced: true,
  state() {
    return {
      todaysWins: null,

      todaysBigTask: null,

      todaysSmallTasks: null,
    };
  },
  mutations,
  actions,
  getters
};
